import React, { useState, useEffect } from "react";
import {
  Switch,
  List,
  Button,
  Icon,
  Modal as ModalAntd,
  notification,
} from "antd";
import Modal from "../../../Modal";
import DragSortableList from "react-drag-sortable"; //revisar en la pag de yarn
import {
  updateMenuApi,
  activateMenuApi,
  deleteMenuApi,
} from "../../../../api/menu";
import { getAccessTokenApi } from "../../../../api/auth";
import AddMenuWebForm from "../AddMenuWebForm";
import EditMenuWebForm from "../EditMenuWebForm";

import "./MenuWebList.scss";

const { confirm } = ModalAntd;

export default function MenuWebList(props) {
  const { menu, setReloadMenuWeb } = props;
  const [listItems, setListItems] = useState([]); //nueva version del menu
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    const listItemsArray = [];
    menu.forEach((item) => {
      listItemsArray.push({
        content: (
          <MenuItem
            item={item}
            activateMenu={activateMenu}
            editMenuWebModal={editMenuWebModal}
            deleteMenu={deleteMenu}
          />
        ),
      });
    });
    setListItems(listItemsArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu]); //para crea un array para react drag sortable

  const activateMenu = (menu, status) => {
    const accesToken = getAccessTokenApi();
    activateMenuApi(accesToken, menu._id, status).then((response) => {
      notification["success"]({
        message: response,
      });
    });
  };

  const onSort = (sortedList, dropEvent) => {
    const accesToken = getAccessTokenApi();

    sortedList.forEach((item) => {
      //por cada iteracion manda 1 item
      const { _id } = item.content.props.item; //extraer el id de cada iteracion
      const order = item.rank;
      updateMenuApi(accesToken, _id, { order }); //lo recibe la funcion de API
    });
  };
  const addMenuWebModal = () => {
    setIsVisibleModal(true);
    setModalTitle("Creando nuevo menú");
    setModalContent(
      <AddMenuWebForm
        setIsVisibleModal={setIsVisibleModal}
        setReloadMenuWeb={setReloadMenuWeb}
      />
    );
  };
  const deleteMenu = (menu) => {
    const accessToken = getAccessTokenApi();
    confirm({
      title: "Eliminando Menu",
      content: `¿Estás seguro que quieres eliminar ${menu.title}?`,
      okText: "Eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk() {
        deleteMenuApi(accessToken, menu._id)
          .then((response) => {
            notification["success"]({
              message: response,
            });
            setReloadMenuWeb(true);
          })
          .catch(() => {
            notification["error"]({
              message: "Error del servidor,intentelo más tarde",
            });
          });
      },
    });
  };
  const editMenuWebModal = (menu) => {
    setIsVisibleModal(true);
    setModalTitle(`Editando menu: ${menu.title}`);
    setModalContent(
      <EditMenuWebForm
        setIsVisibleModal={setIsVisibleModal}
        setReloadMenuWeb={setReloadMenuWeb}
        menu={menu}
      />
    );
  };
  return (
    <div className="menu-web-list">
      <div className="menu-web-list-header">
        <Button type="primary" onClick={addMenuWebModal}>
          Crear menú
        </Button>
      </div>

      <div className="menu-web-list-items">
        <DragSortableList items={listItems} onSort={onSort} type="vertical" />
      </div>
      <Modal
        title={modalTitle}
        isVisible={isVisibleModal}
        setIsVisible={setIsVisibleModal}
      >
        {modalContent}
      </Modal>
    </div>
  );

  function MenuItem(props) {
    const { item, activateMenu, editMenuWebModal, deleteMenu } = props;

    return (
      <List.Item
        actions={[
          <Switch
            defaultChecked={item.active} //menu activo o desactivado
            onChange={(event) => activateMenu(item, event)} //event es el valor de true o false
          />,
          <Button type="primary" onClick={() => editMenuWebModal(item)}>
            <Icon type="edit" />
          </Button>,
          <Button type="danger" onClick={() => deleteMenu(item)}>
            <Icon type="delete" />
          </Button>,
        ]}
      >
        <List.Item.Meta title={item.title} description={item.url} />
      </List.Item>
    );
  }
}
